var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDraggableDotsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#D4DAE3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.213 7.778C.991 7.778 0 8.773 0 10c0 1.227.991 2.222 2.213 2.222 1.223 0 2.214-.995 2.214-2.222 0-1.227-.991-2.222-2.214-2.222zm0 7.778C.991 15.556 0 16.55 0 17.778 0 19.005.991 20 2.213 20c1.223 0 2.214-.995 2.214-2.222 0-1.228-.991-2.222-2.214-2.222zM9.96 4.444c1.223 0 2.214-.994 2.214-2.222C12.174.995 11.183 0 9.96 0 8.738 0 7.747.995 7.747 2.222c0 1.228.991 2.222 2.213 2.222zM2.213 0C.991 0 0 .995 0 2.222 0 3.45.991 4.444 2.213 4.444c1.223 0 2.214-.994 2.214-2.222 0-.59-.233-1.154-.648-1.571C3.363.234 2.8 0 2.213 0zM9.96 15.556c-1.222 0-2.213.994-2.213 2.222 0 1.227.991 2.222 2.213 2.222 1.223 0 2.214-.995 2.214-2.222 0-1.228-.991-2.222-2.214-2.222zm0-7.778c-1.222 0-2.213.995-2.213 2.222 0 1.227.991 2.222 2.213 2.222 1.223 0 2.214-.995 2.214-2.222 0-1.227-.991-2.222-2.214-2.222z",
    transform: "translate(-65.000000, -514.000000) translate(39.000000, 253.000000) translate(26.000000, 252.000000) translate(0.000000, 9.000000)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableDotsWhite);
export default __webpack_public_path__ + "static/media/draggable-dots-white.5959eca3.svg";
export { ForwardRef as ReactComponent };